angular.module('TetherApp').factory(
    'SalesforceDataExtensionsService',
    [
        '$http',
        function ($http) {
            let randomString = function randomString(length, chars) {
                let result = '';
                for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
                return result;
            };

            let indexForms = function (page) {
                let uri = '/api/v1/experience/salesforce-data-extensions/' +
                    randomString(
                        16,
                        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                    );
                if (page != undefined) {
                    uri += '?page=' + page;
                }
                return $http.get(
                    uri,
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    }
                )
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let storeForm = function (data) {
                return $http.post(
                    '/api/v1/experience/salesforce-data-extensions',
                    data,   //OBJECT
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    })
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let updateForm = function (data) {
                let uri = '/api/v1/experience/salesforce-data-extensions/' + data.experience.id;
                return $http.put(
                    uri,
                    data,   //OBJECT
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    }
                )
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let deleteForm = function (extensionId) {
                let uri = '/api/v1/experience/salesforce-data-extensions/' + extensionId + '/' +
                    randomString(
                        16,
                        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                    );
                // console.log('In delete');
                return $http.delete(
                    uri,
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    })
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            return {
                indexForms: indexForms,
                storeForm: storeForm,
                updateForm: updateForm,
                deleteForm: deleteForm
            }
        }
    ]
);
